import { ICompanyPageInfo } from 'interfaces/company/pages-info.company.interface';

export const footerPageInfo: ICompanyPageInfo = { title: 'Rodapé', id: 'rodape' };
